module.exports = __webpack_public_path__ + "img/img-7.69b0b122.png";